import React, { useState } from 'react';

import {
  ApolloQueryResult,
  OperationVariables,
  useMutation,
} from '@apollo/client';

import {
  SET_STRATEGY_ASSET_ENTRY_PRICE,
  SET_STRATEGY_ASSET_LAST_PRICE,
  SET_STRATEGY_ASSET_UNIT,
} from '../http/apollo-queries';
import { extractNumber } from '../helpers/functions';
import { logger } from '../helpers/logger';

export const useAssetInputChanges = (
  refetchStrategies: (
    variables?: Partial<OperationVariables> | undefined
  ) => Promise<ApolloQueryResult<any>>
) => {
  const [assetIdToUpdate, setAssetIdToUpdate] = useState('');
  const [loadingSetAssetEntryPrice, setLoadingSetAssetEntryPrice] =
    useState(false);
  const [loadingSetAssetUnit, setLoadingSetAssetUnit] = useState(false);
  const [loadingSetLastPrice, setLoadingSetLastPrice] = useState(false);

  const [setStrategyAssetEntryPrice] = useMutation(
    SET_STRATEGY_ASSET_ENTRY_PRICE
  );

  const [setStrategyAssetUnit] = useMutation(SET_STRATEGY_ASSET_UNIT);
  const [setStrategyAssetLastPrice] = useMutation(
    SET_STRATEGY_ASSET_LAST_PRICE
  );

  const startUseMutation = (
    s: React.FocusEvent | React.KeyboardEvent,
    originalValue: number
  ) => {
    // NumberFormat return the suffix and prefix if exist: '65$'

    const target = s.target as HTMLInputElement;

    const value = extractNumber(target.value);
    const key = target.name;

    logger.log('AssetInputChange', key);

    if (value !== originalValue) {
      let setFieldValue = setStrategyAssetEntryPrice;
      let setLoading = setLoadingSetAssetEntryPrice;

      if (key === 'unit') {
        setFieldValue = setStrategyAssetUnit;
        setLoading = setLoadingSetAssetUnit;
      } else if (key === 'lastPrice') {
        setFieldValue = setStrategyAssetLastPrice;
        setLoading = setLoadingSetLastPrice;
      }

      setLoading(true);
      setAssetIdToUpdate(target.id);

      const variables = {
        strategyAssetId: target.id,
        [key]: value,
      };

      return setFieldValue({ variables })
        .then(() => refetchStrategies())
        .finally(() => setLoading(false));
    }
  };

  const handleSetChanges = (
    s: React.KeyboardEvent<HTMLInputElement>,
    originalValue: number
  ) => {
    if (s.key === 'Enter') {
      return startUseMutation(s, originalValue);
    } else {
      return Promise.resolve();
    }
  };

  const handleOnBlur = (
    s: React.FocusEvent<HTMLInputElement>,
    originalValue: number
  ) => startUseMutation(s, originalValue);

  return {
    assetIdToUpdate,
    loadingSetAssetEntryPrice,
    loadingSetAssetUnit,
    loadingSetLastPrice,
    handleOnBlur,
    handleChange: handleSetChanges,
  };
};
